<template>
  <!-- class="lg:flex flex-1" -->
  <div>
    <TNavComponent />
    <toTopComponent />
    <introducePage />
    <FooterComponent />
  </div>
</template>

<script>
import TNavComponent from "@/components/new/Nav.vue";
import toTopComponent from "@/components/toTopComponent.vue";
import introducePage from "@/pages/introducePage.vue";
import FooterComponent from "@/components/new/Footer.vue";

export default {
  name: "introView",
  components: { introducePage, TNavComponent, toTopComponent, FooterComponent },
};
</script>
